angular.module('unica_location.location_services')

.factory('LocationDeleteService', function ($http, getBaseApiURL) {

	var locationDeleteService = {};

	locationDeleteService.delete = function (locationId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/location/delete/' + locationId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return locationDeleteService;
});